import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Box } from '@material-ui/core';
import TransTable from './TransTable';
import { agenttransactionhistoryDispatch } from '../../reducers/UserReducer';
const tableHeaders = [
	'TYPE',
	'CART_ID',
	'DOJ',
	'COMMISSION',
	'MARKUP',
	'AMOUNT',
	'AVAL_BAL',
	'PAY_TYPE',
	'DATE',
	'HOLD_S',
	'TRANS_S',
	'DESC',
];

const TransactionHistory = () => {
	const { transagent, agentlogin, loadinguser } = useSelector(
		(state) => state.user
	);
	const [val, setVal] = useState('');
	const [data, setData] = useState('');
	const dispatch = useDispatch();
	useEffect(() => {
		dispatch(
			agenttransactionhistoryDispatch(agentlogin && agentlogin.result.result.id)
		);
	}, []);
	let tranData = [];
	if (loadinguser) {
		console.log('first');
	} else {
		// tranData= transagent &&
		// transagent.result &&
		// transagent.result.result?.length > 0 &&
		// transagent.result.result?.slice().sort((a,b)=>{
		//   return a.id - b.id
		// })
	}
	// console.log('tranData', tranData);
	const handleSearch = (event) => {
		let value = event.target.value.toLowerCase();
		let results = [];
		console.log('filter', value);
		// setVal(value);

		if (event.target.value.toLowerCase() === 'new') {
			results =
				transagent &&
				transagent.result &&
				transagent.result.result?.length > 0 &&
				transagent.result.result?.slice().sort((a, b) => {
					return b.id - a.id;
				});
			setData(results);
		} else if (event.target.value.toLowerCase() === 'old') {
			results =
				transagent &&
				transagent.result &&
				transagent.result.result?.length > 0 &&
				transagent.result.result?.slice().sort((a, b) => {
					return a.id - b.id;
				});
			setData(results);
		} else if (event.target.value.toLowerCase() === 'lh') {
			results =
				transagent &&
				transagent.result &&
				transagent.result.result?.length > 0 &&
				transagent.result.result?.slice().sort((a, b) => {
					return a.amount - b.amount;
				});
			setData(results);
		} else if (event.target.value.toLowerCase() === 'hl') {
			results =
				transagent &&
				transagent.result &&
				transagent.result.result?.length > 0 &&
				transagent.result.result?.slice().sort((a, b) => {
					return b.amount - a.amount;
				});
			setData(results);
		} else {
			results =
				transagent &&
				transagent.result &&
				transagent.result.result.filter((item) => {
					return item.type.toLowerCase().includes(value.toLowerCase());
				});
			setData(results);
		}
		console.log('results', results);
	};
	console.log('Result', data);
	return (
		<>
			<div className='row ' style={{ padding: 15 }}>
				<h3 className='fs-4 mb-3'>Transaction Details</h3>
				<TransTable />
			</div>
		</>
	);
};

export default TransactionHistory;
